import { FC, useEffect, useState, useMemo, useCallback } from 'react'
import { ToastContainer } from 'react-toastify'
import { fetchData, getEncryptedRoute, toasterrormsg, useMenuIdPermissions } from '../../../../reusable'
import { PageTitle } from '../../../../_metronic/layout/core'
import { UserPostsHeader } from './UserPostsHeader'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { Fancybox as NativeFancybox } from '@fancyapps/ui'
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import PostModal from '../../components/PostModal'
import { useLocation, useSearchParams } from "react-router-dom";
import FollowersFollowingModal from '../../components/FollowersFollowingModal'
import { CommentsItem, InterestItem, PostList, TripList, UserProfile } from '../../types/explore'
import { OptimizedImage } from '../../components/OptimizedImage'


const UserPosts: FC = () => {
  let t = Tr()
  const BOTTOM_OFFSET = 50;
  const { urlData } = useMenuIdPermissions()
  const [activeTab, setActiveTab] = useState('posts')
  const [showModal, setShowModal] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingPosts, setIsLoadingPosts] = useState(false)
  const [url, setUrl] = useState("")
  const [profileDetails, setProfileDetails] = useState<UserProfile>();
  const [interestList, setInterestList] = useState<InterestItem[]>([])
  const [searchParams, setSearchParams] = useSearchParams();
  const locationHook = useLocation();

  const [postDetailsCache, setPostDetailsCache] = useState<Record<number, any>>({})
  const [postCommentsCache, setPostCommentsCache] = useState<Record<number, CommentsItem[]>>({})
  const [commentsTotalRecordCache, setCommentsTotalRecordCache] = useState<Record<number, number>>({})

  const [showFollowersModal, setShowFollowModal] = useState(false)
  const [modalType, setModalType] = useState<'followers' | 'following' | "">('')

  // Post navigation states
  const [currentPostIndex, setCurrentPostIndex] = useState(0)
  const [posts, setPosts] = useState<PostList[]>([])
  const [selectedPostDetails, setSelectedPostDetails] = useState<any>(null)
  const [postListLimit] = useState(12) // Increased for better performance
  const [postTotalRecords, setPostTotalRecords] = useState(0)
  const [postListOffset, setPostListOffset] = useState(0)
  const [postIsLoadingMore, setPostIsLoadingMore] = useState(false)

  // trip lazy loading states
  const [trips, setTrips] = useState<TripList[]>([])
  const [isLoadingTrips, setIsLoadingTrips] = useState(false)
  const [tripLimit] = useState(12) // Increased for better performance
  const [tripOffset, setTripOffset] = useState(0)
  const [tripIsLoadingMore, setTripIsLoadingMore] = useState(false)
  const [tripTotalRecords, setTripTotalRecords] = useState(0)

  const postHasMore = posts.length < postTotalRecords
  const tripHasMore = trips.length < tripTotalRecords

  const postListApiCall = async (currentLimit: number, currentOffset: number, isLoadMore = false) => {
    if (isLoadMore) {
      setPostIsLoadingMore(true)
    } else {
      setIsLoadingPosts(true)
    }

    const param: any = {
      limit: currentLimit,
      offset: currentOffset,
      userId: urlData.userId,
    }
    const response = await fetchData('admin/explore/post/list', param)

    if (response.status == '200') {
      const data = response.data
      if (isLoadMore) {
        setPosts(prev => [...prev, ...data.list])
      } else {
        setPosts(data.list)
      }
      setPostTotalRecords(data.totalRecord || 0)
    } else {
      toasterrormsg(response.message)
    }

    if (isLoadMore) {
      setPostIsLoadingMore(false)
    } else {
      setIsLoadingPosts(false)
    }
  }

  const tripListApiCall = async (currentLimit: number, currentOffset: number, isLoadMore = false) => {
    if (isLoadMore) {
      setTripIsLoadingMore(true)
    } else {
      setIsLoadingTrips(true)
    }

    const param: any = {
      limit: currentLimit,
      offset: currentOffset,
      userId: urlData.userId,
    }

    const response = await fetchData('admin/explore/user/trip/list', param)

    if (response.status == '200') {
      const data = response.data

      if (isLoadMore) {
        setTrips(prev => [...prev, ...data.list])
      } else {
        setTrips(data.list)
      }
      setTripTotalRecords(data.totalRecord || 0)
    } else {
      toasterrormsg(response.message)
    }

    if (isLoadMore) {
      setTripIsLoadingMore(false)
    } else {
      setIsLoadingTrips(false)
    }
  }

  const userDetailsApiCall = async () => {
    const param: any = {
      userId: String(urlData.userId),
    }
    const response = await fetchData('admin/viewUserDetail', param)
    if (response.status == '200') {
      const data = response.data[0]
      setProfileDetails(data)
      setUrl(response.url)
      setIsLoading(false)
    } else {
      toasterrormsg(response.message)
    }
  }

  const handlePostDetailsModalHide = useCallback(() => {
    console.log("2");
    console.log(showModal);
    
    setShowModal(false)
    setSelectedPostDetails(null)
  }, [])

  const handleFollowersClick = useCallback(() => {
    setModalType('followers')
    setShowFollowModal(true)
  }, [])

  const handleFollowingClick = useCallback(() => {
    setModalType('following')
    setShowFollowModal(true)
  }, [])
  
const postDetailApiCall = useCallback(async (postId: number) => {
 console.log("1");
    console.log(showModal);
    if (postDetailsCache[postId]) {
      setSelectedPostDetails(postDetailsCache[postId])
      if (!showModal) {
        setShowModal(true)
      }
      return
    }
    const param: any = {
      postId: postId,
    }
    const response = await fetchData('admin/explore/post/detail', param)
    if (response.status == '200') {
      const data = response.data

      setPostDetailsCache(prev => ({
        ...prev,
        [postId]: response.data
      }))
      setSelectedPostDetails(data)
      setShowModal(true)
    } else {
      toasterrormsg(response.message)
    }
}, [postDetailsCache, showModal]) // Add dependencies

  const interestListApiCall = async () => {
    const param: any = {
      language: '',
    }
    const response = await fetchData('admin/interestlist', param)

    if (response.status == '200') {
      const tmp: any = response.data.map((item: any) => {
        return { value: item.interestId, label: item.en_name }
      })
      setInterestList(tmp)
      return tmp
    } else {
      toasterrormsg(response.message)
    }
  }

  const handlePostNavigation = async (newIndex: number) => {
    if (newIndex >= 0 && newIndex < posts.length) {
      setCurrentPostIndex(newIndex)
      const post = posts[newIndex]
      await postDetailApiCall(post.postId)
    }
  }

  const handlePostClick = useCallback(async (postId: any) => {    
    const clickedIndex = posts.findIndex(post => post.postId === postId)
    if (clickedIndex !== -1) {
      setCurrentPostIndex(clickedIndex)
    }
    await postDetailApiCall(postId)
}, [posts, postDetailApiCall]) // Include postDetailApiCall

  useEffect(() => {
    userDetailsApiCall()
    interestListApiCall()
    postListApiCall(postListLimit, postListOffset)
    document.title = "Insayr | Explore User Posts"
  }, [urlData.userId])

  useEffect(() => {
    if (!urlData?.postId) return;
    handlePostClick(urlData.postId);

    const { postId, ...restData } = urlData;

    if (Object.keys(restData).length > 0) {
      const newEncryptedRoute = getEncryptedRoute(
        locationHook.pathname,
        restData
      );
      const newSearch = newEncryptedRoute.split('?')[1];
      setSearchParams(new URLSearchParams(newSearch), { replace: true });
    } else {
      setSearchParams({}, { replace: true });
    }

    window.history.replaceState({}, document.title);
  }, [urlData?.postId]);

  useEffect(() => {
    if (activeTab === 'trips' && trips.length === 0 && !isLoadingTrips) {
      tripListApiCall(tripLimit, tripOffset)
    }
  }, [activeTab, urlData.userId])

  // Optimized scroll handler with throttling
  useEffect(() => {
    let hasReachedBottom = false;
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
          
          if (!hasReachedBottom && scrollTop + clientHeight >= scrollHeight - BOTTOM_OFFSET) {
            hasReachedBottom = true;

            if (postHasMore && !postIsLoadingMore && !isLoadingPosts && activeTab === 'posts') {
              const newOffset = postListOffset + postListLimit;
              setPostListOffset(newOffset);
              postListApiCall(postListLimit, newOffset, true);
            }

            if (tripHasMore && !tripIsLoadingMore && !isLoadingTrips && activeTab === 'trips') {
              const newOffset = tripOffset + tripLimit;
              setTripOffset(newOffset);
              tripListApiCall(tripLimit, newOffset, true);
            }
          }

          if (Math.ceil(scrollTop + clientHeight) < scrollHeight - 100) {
            hasReachedBottom = false;
          }

          ticking = false;
        });

        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [postHasMore, postIsLoadingMore, isLoadingPosts, postListOffset, postListLimit,
    tripHasMore, tripIsLoadingMore, isLoadingTrips, tripOffset, tripLimit, activeTab]);

  const renderPostsSkeleton = () => {
    return (
      <div className="posts-grid">
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <div key={item} className="post-item">
            <Skeleton height={300} containerClassName="skeleton-full-height" />
          </div>
        ))}
      </div>
    )
  }

  // Memoized post grid for better performance
  const PostGrid = useMemo(() => {
    return posts.map((post, index) => (
      <div
        key={post.postId}
        className="post-item"
        onClick={() => handlePostClick(post?.postId)}
      >
        <OptimizedImage
          src={url && post.media[0]?.media ? url + post.media[0].media : ""}
          alt={post.destinationName}
          className="post-image"
          loading={index < 6 ? 'eager' : 'lazy'} // First 6 images load immediately
          priority={index < 3} // First 3 get highest priority
          aspectRatio="1"
        />
        {post.reported && (
          <div className="post-reported-badge">
            <KTIcon iconName="shield-cross" className="fs-5 text-white" iconType='solid' />
          </div>
        )}
        {post.type == "FEATURED" && (
          <div className="post-featured-badge" title='featured'>
            <KTIcon iconName="medal-star" className="fs-5 text-dark" iconType='solid' />
          </div>
        )}
        <div className="post-overlay">
          <div className="post-title">{post.destinationName}</div>
          <div className="post-stats">
            <div className="post-stat">
              <KTIcon iconName='heart' iconType='solid' className='text-danger' />
              <span>{post.like}</span>
            </div>
            <div className="post-stat">
              <KTIcon iconName='message-text-2' iconType='solid' className='text-white' />
              <span>{post.comment}</span>
            </div>
          </div>
          {post.reported && (
            <div className="post-reported-indicator">
              <KTIcon iconName="information-5" className="fs-7 me-1 text-white" />
              <span className="fs-8">Reported</span>
            </div>
          )}
        </div>
      </div>
    ))
  }, [posts, url, handlePostClick])

  const renderPostsGrid = () => {
    return (
      <div className="posts-grid-container">
        {isLoadingPosts ? (
          renderPostsSkeleton()
        ) : posts.length > 0 ? (
          <>
            <div className="posts-grid">
              {PostGrid}
            </div>

            {postIsLoadingMore && (
              <div className="d-flex justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="empty-state">
            <div className="empty-state-icon">
              <img src={toAbsoluteUrl("/media/otherSVG/nopostfound.svg")} alt="No posts Found" loading="lazy" decoding="async" />
            </div>
            <div className="empty-state-title">{t('No Posts Yet')}</div>
            <div className="empty-state-text">{t('When you share posts, they will appear here.')}</div>
          </div>
        )}
      </div>
    )
  }

  const renderTrips = () => {
    return (
      <>
        {isLoadingTrips ? (
          <div className="trips-list">
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <div key={item} className="trip-card">
                <Skeleton height={180} className="mb-3" />
                <Skeleton height={24} width="60%" className="mb-2" />
                <Skeleton height={16} width="40%" />
              </div>
            ))}
          </div>
        ) : trips.length > 0 ? (
          <>
            <div className="trips-list">
              {trips.map((trip, index) => (
                <div key={trip.regionId} className="trip-card">
                  <div className="trip-image-container"
                    onClick={() => {
                      if (!trip.image) return;
                      NativeFancybox.show(
                        trips.map((m: TripList) => ({
                          src: url + m.image,
                          type: 'image',
                        })),
                        {
                          startIndex: index,
                        }
                      );
                    }}
                  >
                    <OptimizedImage
                      src={url && trip.image ? url + trip.image : ""}
                      alt={trip.en_name}
                      className="trip-image"
                      loading={index < 6 ? 'eager' : 'lazy'}
                      priority={index < 3}
                    />
                    <div className="trip-location-badge">
                      <KTIcon iconName='geolocation' className='fs-5' />
                      <span>{trip.en_name}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {tripIsLoadingMore && (
              <div className="d-flex justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="empty-state">
            <div className="empty-state-icon">
              <img src={toAbsoluteUrl("/media/otherSVG/notripsfound.svg")} alt="No trips Found" loading="lazy" decoding="async" />
            </div>
            <div className="empty-state-title">{t('No Trips Yet')}</div>
            <div className="empty-state-text">{t('Your travel destinations will appear here.')}</div>
          </div>
        )}
      </>
    )
  }

  const renderAbout = () => {
    if (!profileDetails) return null

    const interestLabels =
      profileDetails.interest
        ?.split(",")
        .map(Number)
        .map(
          (id) =>
            (interestList as InterestItem[]).find(
              (item) => item.value === id
            )?.label
        )
        .filter(Boolean) || [];

    return (
      <div className="card">
        <div className="card-body">
          <h1 className="fw-bold mb-4">{t('About')}</h1>

          <div className="row mb-4">
            <div className="col-sm-4 fw-semibold fs-4 text-muted">
              {t('Age')}
            </div>
            <div className="col-sm-8 fs-6">
              {profileDetails.age ?? '-'}
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-sm-4 fw-semibold fs-4 text-muted">
              {t('Bio')}
            </div>
            <div className="col-sm-8 fs-6">
              {profileDetails.bio || '-'}
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4 fw-semibold fs-4 text-muted">
              {t('Interests')}
            </div>
            <div className="col-sm-8 d-flex flex-wrap gap-2">
              {interestLabels.length > 0 ? (
                <div className="row mb-3">
                  <div className="col-12">
                    {interestLabels.map((label, i) => (
                      <span key={i} className="badge bg-secondary me-2 fs-6">
                        {label}
                      </span>
                    ))}
                  </div>
                </div>
              ) : <span className="me-2 fs-6">N/A</span>}
            </div>
          </div>
        </div>
      </div>
    )
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'posts':
        return renderPostsGrid()
      case 'trips':
        return renderTrips()
      case 'about':
        return renderAbout()
      default:
        return renderPostsGrid()
    }
  }

  useEffect(() => {
    NativeFancybox.bind('[data-fancybox="gallery"]', {
      // Performance optimizations for Fancybox
      idle: false,
      dragToClose: false,
      Thumbs: false,
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ["close"],
        },
      },
    });
    return () => {
      NativeFancybox.destroy();
    };
  }, []);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [showModal]);

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t("Explore User Posts")}</PageTitle>
      <ToastContainer />

      <UserPostsHeader
        activeTab={activeTab}
        onTabChange={setActiveTab}
        profileData={profileDetails}
        baseUrl={url}
        isLoading={isLoading}
        onFollowersClick={handleFollowersClick}
        onFollowingClick={handleFollowingClick}
      />

      <div>
        {renderContent()}
      </div>

      {selectedPostDetails &&
        <PostModal
          show={showModal}
          onHide={handlePostDetailsModalHide}
          selectedPost={selectedPostDetails}
          profileDetails={profileDetails}
          url={url}
          allPosts={posts}
          currentIndex={currentPostIndex}
          onNavigate={handlePostNavigation}
          commentsCache={postCommentsCache}
          setCommentsCache={setPostCommentsCache}
          commentsTotalRecordCache={commentsTotalRecordCache}
          setCommentsTotalRecordCache={setCommentsTotalRecordCache}
        />}

      <FollowersFollowingModal
        show={showFollowersModal}
        onHide={() => {
          setShowFollowModal(false)
        }}
        type={modalType}
        userId={urlData.userId}
        baseUrl={url}
      />
    </>
  )
}

export { UserPosts }